<template>
	<div class="">
		<form v-if="mode == 'create'" action="#" @submit.prevent>
			<h6 class="font-weight-bold mb-3" >CREATE SUB-MENU</h6>
			<input type="hidden" name="menuId" v-model="$v.formInfo.menuId.$model">

			<div class="col-md-12 form-group mb-3">
				<label> Sub-menu Name: </label>
				<input class="form-control" type="text" placeholder="Enter sub-menu title" v-model.trim="$v.formInfo.subMenuName.$model"  :class="{'is-invalid':$v.formInfo.subMenuName.$error}">
			</div>

			<div class="col-md-12 form-group mb-5">
				<label> Sub-menu URL: </label>
				<input class="form-control" type="text" placeholder="Enter sub-menu url" v-model.trim="$v.formInfo.subMenuUrl.$model"  :class="{'is-invalid':$v.formInfo.subMenuUrl.$error}">
			</div>

			<div class="form-group mb-3 text-center px-3">
				<button class="btn btn-primary btn-sm w-100" :disabled="$v.formInfo.$invalid || creating" type="submit" @click.prevent="creatSubMenu()">
					<span class="mr-3">Create Menu</span> 
					<span v-if="creating" class="spinner-border spinner-border-sm" role="status">
						<span class="sr-only">Loading...</span>
					</span>
				</button>
			</div>
		</form>

		<form v-else action="#" @submit.prevent>
			<h6 class="font-weight-bold mb-3" >UPDATE SUB-MENU</h6>

			<input type="hidden" name="menuId" v-model="$v.subMenuData.menuId.$model">

			<input type="hidden" name="id" v-model="$v.subMenuData.id.$model">

			<div class="col-md-12 form-group mb-3">
				<label> Sub-menu Name: </label>
				<input class="form-control" type="text" placeholder="Enter sub-menu title" v-model.trim="$v.subMenuData.subMenuName.$model"  :class="{'is-invalid':$v.subMenuData.subMenuName.$error}">
			</div>

			<div class="col-md-12 form-group mb-5">
				<label> Sub-menu URL: </label>
				<input class="form-control" type="text" placeholder="Enter sub-menu url" v-model.trim="$v.subMenuData.subMenuUrl.$model"  :class="{'is-invalid':$v.subMenuData.subMenuUrl.$error}">
			</div>

			<div class="row justify-content-between mx-3">
				<button class="btn btn-danger btn-sm px-5" type="submit" @click="$emit('showupdatemenu')"> 
					Cancel
				</button>

				<button class="btn btn-primary btn-sm px-5" :disabled="$v.subMenuData.$invalid || creating" type="submit" @click.prevent="updateMenu()"> 
					<span class="mr-3">Update Menu</span>
					<span v-if="creating" class="spinner-border spinner-border-sm" role="status">
						<span class="sr-only">Loading...</span>
					</span>
				</button>
			</div>
		</form>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
export default {
	name: "CreateSubMenu",
	
	props: [
		'mode',
		'mainMenuId',
		'subMenuData',
	],

	computed: {
        ...mapState(['token']),
	},

	data() {
		return {
			creating: false,
			formInfo: {
				menuId: null,
				subMenuName: null,
				subMenuUrl: null,
			}
		}
	},

	validations: {
		formInfo: {
			menuId: {required},
			subMenuName: {required},
			subMenuUrl: {required},
		},

		subMenuData: {
			id: {required},
			menuId: {required},
			subMenuName: {required},
			subMenuUrl: {required},
		},
	},

	mounted(){
		this.formInfo.menuId = this.mainMenuId;
	},

	methods: {
		creatSubMenu(){
			this.$v.formInfo.$touch();
			if (!this.$v.formInfo.$invalid && !this.$v.formInfo.$error) {
				// send the request for creating
				this.creating = true;

				const baseU = `${this.$urlAuth}/submenu/create`;
				this.$http.post(baseU, this.formInfo, {
					headers:{
                        "x-access-token":this.token
                    }
				})
				.then((result) => {
					this.creating=false;
					if(result.data.data.code =='S201'){
						this.$toastr.s(result.data.data.message);
						
						// Add data to the Menu List
						const menuObj = {
							menuId: this.formInfo.menuId,
							subMenuUrl: this.formInfo.subMenuUrl,
							subMenuName: this.formInfo.subMenuName,
						};
						this.$emit('addtosubmenu', menuObj);

						// clear the fields
						this.formInfo.menuId = null;
						this.formInfo.subMenuUrl = null;
						this.formInfo.subMenuName = null;
					}else{
						this.$toastr.e(result.data.data.message);
					}
				}).catch(er =>{
					console.log(er);
					this.creating=false;
					if(er.message == 'Network Error'){
						this.$toastr.e("Cannot connect to serve. Check your internet connection");
					}else{
						this.$toastr.e(er.message);
					}
				})
			}else{
				this.$toastr.e("Fill all fields well");
				return;
			}
		},

		updateMenu(){
			this.$v.subMenuData.$touch();
			if (!this.$v.subMenuData.$invalid && !this.$v.subMenuData.$error) {
				// send the request for creating
				this.creating = true;

				const baseU = `${this.$urlAuth}/submenu/edit`;
				this.$http.post(baseU, this.subMenuData, {
					headers:{
                        "x-access-token":this.token
                    }
				})
				.then((result) => {
					this.creating=false;
					if(result.data.data.code =='S200'){
						this.$toastr.s(result.data.data.message);
						
						// Add data to the Menu List
						const menuObj = {
							id: this.subMenuData.id,
							menuId: this.subMenuData.menuId,
							subMenuName: this.subMenuData.subMenuName,
							subMenuUrl: this.subMenuData.subMenuUrl,
						};
						this.$emit('updatesubmenulist', menuObj);

					}else{
						this.$toastr.e(result.data.data.message);
					}
				}).catch(er =>{
					console.log(er);
					this.creating=false;
					if(er.message == 'Network Error'){
						this.$toastr.e("Cannot connect to serve. Check your internet connection");
					}else{
						this.$toastr.e(er.message);
					}
				})
			}else{
				this.$toastr.e("Fill all fields well");
				return;
			}
		},
	}
}
</script>